var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import SessionExpiredView from '@/template/views/SessionExpiredView.vue';
import LoginView from '@/loginApp/template/views/LoginView.vue';
import RegisterOrganisationView from '@/loginApp/template/views/registerOrganisation/RegisterOrganisationView.vue';
import RegisterAdminUserView from '@/loginApp/template/views/registerAdminUser/RegisterAdminUserView.vue';
import AccessibilityStatement from '@/template/components/AccessibilityStatement.vue';
import PrivacyPolicy from '@/template/components/PrivacyPolicy.vue';
import ForgotPasswordView from '@/loginApp/template/views/passwordRecovery/ForgotPasswordView.vue';
import ResetPasswordView from '@/loginApp/template/views/passwordRecovery/ResetPasswordView.vue';
import UserInfoView from '@/loginApp/template/views/registerBasicUser/UserInfoView.vue';
import ConfirmationView from '@/loginApp/template/views/registerBasicUser/ConfirmationView.vue';
export var routes = getDefaultRoutes();
/**
 *
 * Creates the default set of routes - excluding routes which are dependent on the feature configuration
 *
 **/
export function getDefaultRoutes() {
    return getLoginAppRoutes();
}
/**
 *
 * Creates routes based on the given feature configuration
 *
 **/
export function getLoginAppRoutes() {
    var routes = [{
            path: '*',
            redirect: { name: 'login' }
        }];
    routes.push.apply(routes, __spread(getStaticMenuRoutes()));
    routes.push(getSessionExpiredRoute());
    routes.push(getLoginRoute());
    return routes;
}
function getSessionExpiredRoute() {
    return {
        name: 'sessionExpired',
        path: '/sessionExpired',
        component: SessionExpiredView,
        meta: {
            hideNav: true
        }
    };
}
function getLoginRoute() {
    return {
        name: 'login',
        path: '/',
        component: LoginView,
        meta: {
            title: 'Login.WebService.Title'
        }
    };
}
function getStaticMenuRoutes() {
    return [{
            name: 'accessibility-statement',
            path: '/accessibilityStatement',
            component: AccessibilityStatement,
            meta: {
                title: 'AccessibilityStatement',
                hideNav: true
            }
        },
        {
            name: 'privacy-policy',
            path: '/privacyPolicy',
            component: PrivacyPolicy,
            meta: {
                title: 'PrivacyPolicy',
                hideNav: true
            }
        },
        {
            name: 'qa-link',
            path: '/qaLink',
            meta: {
                title: 'Qalink',
                hideNav: true
            }
        },
        {
            name: 'forgot-password',
            path: '/forgotPassword',
            component: ForgotPasswordView,
            meta: {
                title: 'PasswordRecovery.ForgotPassword.Title'
            }
        },
        {
            name: 'reset-password',
            path: '/resetPassword/:email?/:token?',
            component: ResetPasswordView,
            meta: {
                title: 'PasswordRecovery.ResetPassword.Title'
            }
        },
        {
            name: 'register-organisation',
            path: '/registerOrganisation',
            component: RegisterOrganisationView,
            meta: {
                title: 'Login.NewOrganisation.Button',
                isRegistration: true
            }
        },
        {
            name: 'register-basic-user',
            path: '/registerBasicUser/:userId?',
            component: UserInfoView,
            meta: {
                title: 'Registration.Title',
                isRegistration: true
            }
        },
        {
            name: 'register',
            path: '/register/:userId?',
            component: RegisterAdminUserView,
            meta: {
                title: 'Registration.Title',
                isRegistration: true
            }
        },
        {
            name: 'register-confirmation',
            path: '/confirmation/:email?',
            component: ConfirmationView,
            meta: {
                title: 'Registration.ConfirmationTitle'
            }
        }];
}
